import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  Select,
  Button,
  Upload,
  ColorPicker,
  Row,
  Col,
  Card,
  Spin,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const OtherCardForm = ({ form, onFinish, initialValues, isLoading }) => {
  const [imageFileList, setImageFileList] = useState([]);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const axiosPrivate = useAxiosPrivate();

  useEffect(() => {
    if (initialValues) {
      // Convert decimal color to hex for color picker
      let colorValue = initialValues.color
        ? convertDecimalToHex(Number(initialValues.color))
        : undefined;

      const formValues = {
        companyName: initialValues.companyName || "",
        color: colorValue,
        isCommonlyUsed: initialValues.isCommonlyUsed,
        status: initialValues.status,
      };
      form.setFieldsValue(formValues);

      // Set image if exists
      if (initialValues.logoUrl) {
        // Don't set fileList for existing image as it's stored on server
      }
    }
  }, [initialValues, form]);

  // Convert decimal to RGBA hex string for color picker
  const convertDecimalToHex = (decimalColor) => {
    // Convert decimal to hex string and ensure it has 8 characters (ARGB format)
    const hexColor = decimalColor.toString(16).padStart(8, "0");

    // Extract ARGB components
    const alpha = hexColor.slice(0, 2);
    const red = hexColor.slice(2, 4);
    const green = hexColor.slice(4, 6);
    const blue = hexColor.slice(6, 8);

    // Return as hex string in format expected by color picker
    return `#${red}${green}${blue}${alpha}`;
  };

  // Convert hex color string from color picker to decimal
  const convertHexToDecimal = (hexColor) => {
    // Remove the '#' if present
    hexColor = hexColor.replace("#", "");

    // Extract RGBA components (ColorPicker returns #RRGGBBAA format)
    const red = hexColor.slice(0, 2);
    const green = hexColor.slice(2, 4);
    const blue = hexColor.slice(4, 6);
    const alpha = hexColor.slice(6, 8) || "ff"; // Default to fully opaque if no alpha

    // Reorder to ARGB format for the backend
    const argbHex = `${alpha}${red}${green}${blue}`;

    // Convert to decimal
    return parseInt(argbHex, 16);
  };

  // Process form data before submission
  const handleFinish = (values) => {
    // Process color - convert from hex to decimal
    if (values.color) {
      let hexString;

      // Check if color is an object with toHexString or a string already
      if (typeof values.color === "object" && values.color.toHexString) {
        hexString = values.color.toHexString();
      } else if (typeof values.color === "string") {
        hexString = values.color;
      } else {
        // If it's neither an object with toHexString nor a string, use a default
        console.warn("Unexpected color format:", values.color);
        hexString = "#000000FF"; // Default to black if format is unknown
      }

      values.color = convertHexToDecimal(hexString);
    }

    // Add file to form data if exists
    if (imageFileList.length > 0) {
      values.logo = imageFileList[0].originFileObj;
    }

    onFinish(values);
  };

  return (
    <Spin spinning={isLoading || isSubmitLoading}>
      <Card title="Kart Bilgileri">
        <Form form={form} layout="vertical" onFinish={handleFinish}>
          <Row gutter={[16, 0]}>
            <Col span={12}>
              <Form.Item
                name="companyName"
                label="Şirket Adı"
                rules={[
                  { required: true, message: "Lütfen şirket adını giriniz" },
                ]}>
                <Input placeholder="Şirket Adı" />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                name="color"
                label="Renk"
                rules={[
                  { required: true, message: "Lütfen bir renk seçiniz" },
                ]}>
                <ColorPicker showAlpha format="hex" />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                name="isCommonlyUsed"
                label="Sık Kullanılan"
                rules={[
                  {
                    required: true,
                    message: "Lütfen sık kullanılan durumunu seçiniz",
                  },
                ]}>
                <Select placeholder="Seçiniz">
                  <Select.Option value={true}>Evet</Select.Option>
                  <Select.Option value={false}>Hayır</Select.Option>
                </Select>
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                name="status"
                label="Durum"
                rules={[{ required: true, message: "Lütfen durumu seçiniz" }]}>
                <Select placeholder="Seçiniz">
                  <Select.Option value={1}>Aktif</Select.Option>
                  <Select.Option value={0}>Pasif</Select.Option>
                </Select>
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item name="logo" label="Logo">
                <Upload
                  beforeUpload={() => false}
                  listType="picture"
                  maxCount={1}
                  onChange={(e) => setImageFileList(e.fileList)}
                  accept="image/png, image/jpeg"
                  fileList={imageFileList}>
                  <Button icon={<UploadOutlined />}>Logo Yükle</Button>
                </Upload>
              </Form.Item>
            </Col>

            {initialValues?.logoUrl && (
              <Col span={24}>
                <Form.Item label="Mevcut Logo">
                  <img
                    src={initialValues.logoUrl}
                    alt="Logo"
                    style={{ maxWidth: "200px", marginBottom: "10px" }}
                  />
                </Form.Item>
              </Col>
            )}
          </Row>

          <Form.Item>
            <Button type="primary" htmlType="submit" style={{ marginTop: 8 }}>
              Kaydet
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </Spin>
  );
};

export default OtherCardForm;
